import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  ListItemIcon,
  Menu,
  MenuItem,
  Pagination,
  Select,
  Stack,
  TextField,
  Typography,
  Grid,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Switch,
} from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { PERSONAL_CABINET_PATH, VOUCHERS_PROMOCODES_PATH } from "pages/paths";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Calendar,
  CloseIcon,
  DeleteIcon,
  ImportExcelFile,
  MinusIcon,
  MoreIcon,
} from "assets/icons/index";


import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { SubVoucherEditModal } from "shared/ui/adminPanel/subVoucherEditModal/SubVoucherEditModal";
import { updateSubVoucher } from "entities/admin/model/thunk/updateSubVoucher";
import { setExpirationDate, setStartKitIssueType } from "entities/admin/model/slice";
import { changeVoucherStatus } from "entities/admin/model/thunk/changeVoucherStatus";
import { updateVoucher } from "entities/admin/model/thunk/EditVoucherName";
import { getVoucherPromocodesByVoucherId } from "entities/admin/model/thunk/getVoucherPromocodesByVoucherId";
import VoucherListTable from "../../../../admin/ui/Vouchers/VoucherListTable/VoucherListTable";
import { getUnssignedCountPerDistance } from "entities/viewer/model/thunks/getUnssignedCountPerDistance";
import closeIcon from "assets/images/modal/x.svg";
import styles from "./SubVoucher.module.scss";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Remove } from "@mui/icons-material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useAppSelector } from "shared/lib/hooks/hooks";
import { getMarathonDistances } from "entities/admin/model/thunk/getMarathonDistances";
import { getMarathonById } from "entities/admin/model/thunk/getMarathonById";
import { Input, Label, createVoucherAutoComplete, defaultCircularProgress, ModalTitle } from "entities/admin/lib/MUIStyles/MUIStyles";
import CircularProgress from "@mui/material/CircularProgress";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import { addPromocodesToVouchers } from "entities/admin/model/thunk/addPromocodesToVouchers";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { addSlotsValidation } from "entities/admin/lib/formValidation/addSlotsValidation";
import { getSubVouchersCreateThunk } from "entities/viewer/model/thunks/getSubVouchersCreateThunk";
import { setSubvaucherResponsibleUsers } from "entities/viewer/model/slice";
import editIcon from "assets/images/admin/editVoucher.svg";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


const SubVoucher = ({
  isAdmin,
  marathonName,
  voucherName,
  corporateClientName,
  voucherId,
}) => {
  const { state } = useLocation()
  const { corporateClientId, subVoucherId } = useParams();
  const params = useParams();
  const [inputValue, setInputValue] = useState("");
  const [errorFinal, setErrorFinal] = useState();
  const [activeModal, setActiveModal] = useState(null);
  const { t } = useTranslation();
  const [activeStatus, setActiveStatus] = useState();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isAddNewSlotesModalOpen, setAddNewSlotesModalOpen] = useState(false);
  const unssignedCountPerDistance = useSelector(
    (state) => state?.personalCabinet?.unssignedCountPerDistance
  );
  const userRole = useSelector((state) => state.users.userRole);
  const subVouchers = useSelector(
    (state) => state?.personalCabinet?.subVouchers
  );

  const users = useAppSelector((state) => state.marathon.users);
  const subVouchersLoading = useSelector(
    (state) => state?.personalCabinet?.subVouchersLoading
  );
  const marathonDistances = useAppSelector(
    (state) => state.marathon.marathonDistances
  );
  const responsibleUsers = useAppSelector(
    (state) => state.marathon.responsibleUsers
  );
  const isGetUsersLoading = useAppSelector(
    (state) => state.marathon.isGetUsersLoading
  );
  const editVoucherLoading = useAppSelector(
    (state) => state.marathon.editVoucherLoading
  );
  const isVoucherActive = useAppSelector(
    (state) => state.marathon.isVoucherActive
  );
  const location = useLocation();
  const marathonId = location.state?.marathonId;
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [currentUser, setCurrentUser] = useState({});
  const [selectedUsers, setSelectedUsers] = useState(responsibleUsers);
  const voucherPromocodesByVoucherId = useAppSelector((state) => state.marathon.voucherPromocodesByVoucherId);
  const [canCreateSubVoucher, setCanCreateSubVoucher] = useState(false);
  const isSubvoucher = subVouchers?.query?.some(
    (subvoucher) => subvoucher?.id === voucherPromocodesByVoucherId?.id
  );
  const startKitIssueType = useAppSelector(
    (state) => state.marathon.startKitIssueType
  );
  const expireDate = useAppSelector((state) => state.marathon.expirationDate);
  const endDateAcceptingApplications = useAppSelector(
    (state) => state.marathon.endDateAcceptingApplications
  );
  const [editVoucherName, setEditVoucherName] = useState('');
  const [editExpirationDate, setEditExpirationDate] = useState('');

  const [editVoucherStartKitIssueType, setEditVoucherStartKitIssueType] =
    useState(1);
  const [isEditVoucherModalOpen, setIsEditVoucherModalOpen] =
    useState(state?.isOpenEditVoucher || false);

  const [showExpirationDate, setShowExpirationDate] =
    useState(false);
  const [isInvalidExpirationDate, setIsInvalidExpirationDate] = useState(false);
  const [expirationDateIndefinite, setExpirationDateIndefinite] =
    useState(false);
  const [isVoucherDeactiveModalOpen, setIsVoucherDeactivateModalOpen] =
    useState(false);
  const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(false);

  const [isVoucherActivateModalOpen, setIsVoucherActivateModalOpen] =
    useState(false);

  const handleEditVoucherModalClose = () => {
    setIsEditVoucherModalOpen(false);
    setShowExpirationDate(false);
  }
  const handleVoucherDeactivateModalClose = () =>
    setIsVoucherDeactivateModalOpen(false);
  const handleExpiredModalClose = () => {
    setIsExpiredModalOpen(false);
  }
  const handleVoucherActivateModalClose = () =>
    setIsVoucherActivateModalOpen(false);

  const {
    control,
    watch,
    setValue,
    handleSubmit,
    reset,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addSlotsValidation),
    defaultValues: { fields: [{ value: "", slots: "" }] },
  });

  const handleMenuClick = (event) => setAnchorEl(event.currentTarget);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  const navigate = useNavigate();

  const handleClose = () => setAnchorEl(null);
  const open = Boolean(anchorEl);

  const showTable = false;

  const handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  useEffect(() => {
    if (userRole === "Owner") {
      dispatch(getUnssignedCountPerDistance({ voucherId }));
    } else {
      dispatch(getUnssignedCountPerDistance({ voucherId: subVoucherId }));
    }
  }, [userRole, voucherId, subVoucherId]);

  const columns = useMemo(() => [
    {
      accessorKey: "id",
      header: "№",
      size: 70,
      Cell: ({ row }) => {
        return <>{row.index + 1 + (pagination.page - 1) * pagination.pageSize}</>;
      },
      enableSorting: false,
    },
    {
      accessorKey: "startKitIssueType",
      header: t("corporateClient.startKitIssueType"),
      size: 150,
      Cell: (value) => {
        switch (value.renderedCellValue) {
          case "Individual":
            return t("corporateClient.individual");
          case "Сorporate":
            return t("corporateClient.corporate");
          default:
            break;
        }
        return <Box>{value.renderedCellValue}</Box>;
      },
    },
    {
      accessorKey: "voucherName",
      header: t("corporateClient.subvoucher"),
      size: 200,
      Cell: (value) => {
        return <Box>{value.renderedCellValue}</Box>;
      },
    },
    {
      accessorKey: "totalPromocodes",
      header: t("corporateClient.slots"),
      size: 70,
      Cell: (value) => {
        const subvoucher = value.row.original;
        return (
          <Box>
            {subvoucher.usedPromocodes}/{subvoucher.totalPromocodes}
          </Box>
        );
      },
    },
    {
      accessorKey: "expirationDate",
      header: t("corporateClient.active_until"),
      size: 100,
      Cell: (value) => dayjs(value.renderedCellValue).format("DD.MM.YYYY"),
    },
    {
      accessorKey: "isActive",
      header: t("corporateClient.status"),
      size: 100,
      Cell: (value) => (
        <Button
          sx={{
            display: "flex",
            alignItems: "center",
            color: value.renderedCellValue ? "#237657" : "#FA0E00",
            textTransform: "capitalize",
            borderRadius: "4px",
            background: value.renderedCellValue ? "#E8FFE0" : "#FFECEB",
            fontFamily: "Raleway",
            fontSize: "10px",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "normal",
          }}
        >
          {value.renderedCellValue
            ? t("corporateClient.active")
            : t("corporateClient.un_active")}
        </Button>
      ),
    },
    {
      accessorKey: "action",
      header: "",
      size: 100,
      Cell: (value) => {
        const clickedSubVoucherId = value.row.original.id;
        const voucherName = value.row.original.voucherName;
        const isActive = value.row.original.isActive;
        setActiveStatus(isActive);
        return (
          <div onClick={handleClick}>
            <SubVoucherEditModal
              pageSubVoucherId={subVoucherId}
              corporateClientId={corporateClientId}
              clickedSubVoucherId={clickedSubVoucherId}
              name={voucherName}
              isActive={isActive}
            />
          </div>
        );
      },
    },
  ]);


  useEffect(() => {
    if (voucherId) {
      dispatch(
        getVoucherPromocodesByVoucherId({
          voucherId: Number(voucherId),
          page,
          pageSize,
        })
      );
    }
  }, [voucherId, page, pageSize]);

  useEffect(() => {
    if (marathonId) {
      dispatch(getMarathonDistances(marathonId));
      dispatch(getMarathonById(marathonId));
    }
  }, [marathonId]);

  const editVoucherSubmit = async (e) => {
    e.preventDefault();
    if (params.voucherId) {
      const voucherData = {
        id: +params.voucherId,
        name: editVoucherName,
        startKitIssueType: editVoucherStartKitIssueType,
        isActive: isVoucherActive,
        canCreateSubVoucher: true,
        expirationDate: editExpirationDate,
      };

      const response = await dispatch(updateVoucher(voucherData));

      if (response.meta.requestStatus === "fulfilled") {
        dispatch(setExpirationDate(editExpirationDate));
        dispatch(setStartKitIssueType(editVoucherStartKitIssueType));

        dispatch(
          getSubVouchersCreateThunk({
            voucherId: params.voucherId,
            corporateClientId,
            pagination,
          })
        );
        handleEditVoucherModalClose();
      }
    }
  };

  const handleIsActivationVoucher = async (
    e,
    isActive
  ) => {
    e.preventDefault();

    if (!params.voucherId) return;

    try {
      const response = await dispatch(changeVoucherStatus({ id: +params.voucherId, isActive })).unwrap();

      dispatch(
        getSubVouchersCreateThunk({
          voucherId: params.voucherId,
          corporateClientId,
          pagination,
        })
      );

      handleVoucherDeactivateModalClose();
      handleVoucherActivateModalClose();
    } catch (error) {
      console.error("Ошибка при обновлении ваучера:", error);
    }
  };


  const dispatch = useDispatch();
  useEffect(() => {
    if (corporateClientId) {
      dispatch(
        getSubVouchersCreateThunk({
          voucherId: subVoucherId,
          corporateClientId,
          pagination,
        })
      )
    } else if (voucherId) {
      dispatch(
        getSubVouchersCreateThunk({
          voucherId: voucherId,
          corporateClientId,
          pagination,
        })
      );
    }
  }, [corporateClientId, dispatch, pagination, subVoucherId, voucherId, t, activeStatus]);
  useEffect(() => {
    if (isAddNewSlotesModalOpen) {
      dispatch(getMarathonDistances(marathonId));
    }
  }, [isAddNewSlotesModalOpen]);

  useEffect(() => {
    if (!voucherName) return;

    const saved = localStorage.getItem(`voucher_${voucherName}_indefinite`);
    if (saved !== null) {
      const isIndefinite = JSON.parse(saved);
      setExpirationDateIndefinite(isIndefinite);
      setShowExpirationDate(isIndefinite);

      if (isIndefinite && endDateAcceptingApplications) {
        const endDate = dayjs(endDateAcceptingApplications)
          .set("hour", 12)
          .set("minute", 0)
          .set("second", 0)
          .toISOString();
        setEditExpirationDate(endDate);
      }
    }
  }, [isEditVoucherModalOpen, voucherName]);

  const getPromocodeColor = (count) => {
    if (count <= 3) return "#FA0E00";
    if (count <= 15) return "#BA8E1E";
    if (count >= 20) return "#237657";

    return "#CBD5E1";
  };

  const handleOnPageChange = (event, page) =>
    setPagination((prevPagination) => ({
      ...prevPagination,
      page,
    }));

  const table = useMaterialReactTable({
    columns,
    data: subVouchers?.query || [],
    enableTopToolbar: false,
    enableColumnActions: false,
    manualPagination: true,
    onPaginationChange: setPagination,
    initialState: { density: "comfortable" },
    enablePagination: false,
    state: { pagination, isLoading: subVouchersLoading },
    muiTableHeadRowProps: () => ({
      style: {
        background: "#ECF2F7",
        borderRadius: "20px",
        border: "none",
        boxShadow: "none",
      },
    }),
    muiTablePaperProps: {
      style: {
        borderTopLeftRadius: "15px",
        borderTopRightRadius: "15px",
        boxShadow: "none ",
      },
    },
    muiTableHeadCellProps: {
      sx: {
        height: "10px",
        fontSize: "12px",
        lineHeight: "20px",
        fontWeight: 600,
        fontFamily: "Raleway",
        border: "none",
        "& .MuiTableSortLabel-icon": {
          color: "black !important",
          opacity: 1,
        },
      },
    },
    muiBottomToolbarProps: {
      style: {
        border: "none",
        boxShadow: "none ",
      },
    },
    muiTableBodyCellProps: {
      style: {
        fontSize: "12px",
        fontVariantNumeric: "lining-nums proportional-nums",
        textOverflow: "ellipsis",
        fontFeatureSettings: '"liga" off',
        lineHeight: "20px",
        fontWeight: 500,
        fontFamily: "Raleway",
        color: "#3E444A",
        border: "none",
      },
    },
    muiTableBodyRowProps: ({ row }) => ({
      onClick: () => {
        const subVoucher = row.original;
        dispatch(setSubvaucherResponsibleUsers(subVoucher))
        if (!subVoucher.id) {
          return;
        }
        !isAdmin
          ? navigate(
            `/${PERSONAL_CABINET_PATH}/${VOUCHERS_PROMOCODES_PATH}/${subVoucher.id}`
          )
          : navigate(`/admin_panel/vouchers/promocodes/${subVoucher.id}`);
      },
      sx: {
        //stripe the rows, make odd rows a darker color
        cursor: "pointer",
        "& tr:nth-of-type(even) > td": {
          backgroundColor: "#F5FAFF",
        },
      },
    }),
    muiPaginationProps: {
      count: subVouchers?.totalCount,
      page: pagination.page,
      onPageChange: handleOnPageChange,
      rowsPerPage: pagination.pageSize,
    },
  });



  const handleAddNewSlotesModalClose = () => {
    setAddNewSlotesModalOpen(false);
    reset();
  };

  const { fields, append, remove } = useFieldArray({
    control,
    name: "fields",
  });

  const watchFields = watch("fields");

  const onSubmit = async (data) => {
    const promocodeData = data.fields.map((field) => ({
      distanceId: field.value,
      quantity: field.slots,
    }));

    const requestBody = {
      voucherId,
      promocodes: promocodeData,
    };
    try {
      await dispatch(addPromocodesToVouchers(requestBody));

      setAddNewSlotesModalOpen(false);
      reset();

      if (userRole === "Owner") {
        dispatch(getUnssignedCountPerDistance({ voucherId }));
      } else {
        dispatch(getUnssignedCountPerDistance({ voucherId: subVoucherId }));
      }

      if (subVoucherId) {
        dispatch(
          getSubVouchersCreateThunk({
            voucherId: subVoucherId,
            corporateClientId,
            pagination,
          })
        );
      }
    } catch (error) {
      console.error(
        "Ошибка при добавлении промокодов или получении данных:",
        error
      );
    }
  };
  const now = dayjs().startOf("day");
  const maxDate = dayjs(endDateAcceptingApplications);
  const isRegistrationOver = maxDate && maxDate.isBefore(now);
  const handleRemoveUser = (userId) => {
    setSelectedUsers((prevSelectedUsers) =>
      prevSelectedUsers.filter((user) => user?.id !== userId)
    );
  };

  const availableOptions = users?.query
    ?.filter(
      (user) =>
        !selectedUsers?.find(
          (selectedUser) => selectedUser?.email === user?.email
        )
    )
    .filter(
      (user) =>
        user?.email?.toLowerCase().includes(inputValue.toLowerCase()) ||
        user?.name?.toLowerCase().includes(inputValue.toLowerCase()) ||
        user?.surname?.toLowerCase().includes(inputValue.toLowerCase())
    );

  return (
    <div
      style={{
        width: "100%",
        flex: "1",
        maxWidth: "1280px",
        margin: "15px auto 0",
      }}
    >
      <span
        style={{ color: "#0090D1", whiteSpace: "pre", cursor: "pointer" }}
        onClick={() =>
          navigate(location.state?.from)
        }
      >
        {t("corporateClient.vouchers")} &gt;{" "}
      </span>
      <span style={{ whiteSpace: "pre" }}> {corporateClientName}</span>
      <div style={{ margin: "20px 0" }}>
        {" "}
        {marathonName} {marathonName ? "|" : ""} {voucherName}
      </div>
      {
        (userRole === "Owner" || userRole === "Admin") && (
          <div className={styles.voucherNameContainer}>
            <h2 className={styles.voucherName}>{voucherName}</h2>
            <Button type="button" onClick={handleMenuClick}>
              <MoreIcon />
            </Button>
          </div>
        )
      }
      <Box sx={{ display: "flex", gap: "16px" }}>
        <Box className="container-personalCabinet" sx={{ maxWidth: "350px" }}>
          <h2
            className="title-personalCabinet"
            style={{ marginBottom: "28px" }}
          >
            {t("corporateClient.distances")}
          </h2>
          <Box
            sx={{
              maxWidth: 400,
              backgroundColor: "#F1F5F9",
              padding: "8px",
              borderRadius: 2,
              maxHeight: "50vh",
              overflowY: "auto",
              "&::-webkit-scrollbar": { width: "6px" },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#CBD5E1",
                borderRadius: "6px",
              },
              "&::-webkit-scrollbar": { display: "none" },
              "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
            }}
          >
            {unssignedCountPerDistance &&
              unssignedCountPerDistance.length > 0 ? (
              unssignedCountPerDistance.map((promocode) => (
                <Box
                  key={promocode?.key}
                  sx={{
                    mt: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    p: "12px 16px",
                    backgroundColor: "#FFFFFF",
                    borderRadius: 2,
                    width: "100%",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      minWidth: 0,
                      whiteSpace: "wrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {t("vouchersPage.freeSlotsAtDistance")}{" "}
                    {promocode?.distanceName}
                  </Typography>

                  <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                      borderColor: "#CBD5E1",
                      borderStyle: "dashed",
                      alignSelf: "stretch",
                    }}
                  />

                  <Typography
                    sx={{
                      minWidth: 40,
                      textAlign: "center",
                      color: getPromocodeColor(promocode?.promocodeCount),
                    }}
                  >
                    {promocode?.promocodeCount}
                  </Typography>
                </Box>
              ))
            ) : (
              <Typography sx={{ textAlign: "center", color: "#CBD5E1" }}>
                {t("vouchersPage.noAvailableDistances")}
              </Typography>
            )}
          </Box>
        </Box>
        <div className={"container-personalCabinet"}>
          <h2
            className="title-personalCabinet"
            style={{ marginBottom: "28px" }}
          >
            {t("corporateClient.subvouchers")}
          </h2>
          <Box style={{ overflowX: "auto", flex: 1 }}>
            <Box></Box>
            <MaterialReactTable table={table || []} />
          </Box>
        </div>
      </Box>
      {
        subVouchers?.query.length === 0 ? null : (
          <Stack
            spacing={2}
            sx={{
              margin: "30px auto 20px auto",
              alignItems: "center",
            }}
          >
            <Pagination
              count={Math.ceil(subVouchers?.count / pagination.pageSize) || 5}
              page={pagination.page}
              onChange={handleOnPageChange}
              color="primary"
              size="medium"
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        )
      }
      {
        showTable && (
          <VoucherListTable
            subVoucherId={subVoucherId}
            corporateClientId={corporateClientId}
            pagination={pagination}
          />
        )
      }
      <Menu
        anchorEl={anchorEl}
        open={open}
        disableScrollLock={true}
        sx={{
          padding: "0px",
          "& .MuiPaper-root": {
            borderRadius: "16px",
            padding: "0px",
          },
          ".MuiModal-root": {
            padding: "0px",
            margin: "0px",
          },
        }}
        style={{ borderRadius: "10px" }}
        onClose={handleClose}
      >
        <MenuItem
          className={styles.voucherMenuItem}
          sx={{
            display: "flex",
            padding: "10px",
            fontFamily: "Raleway",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#3E444A",
            borderRadius: "8px",
            "&:hover": { background: "#F0F8FF", color: "#0090D1" },
          }}
          onClick={() => {
            handleClose();
            setAddNewSlotesModalOpen(true);
          }}
        >
          <ListItemIcon sx={{ minWidth: "24px" }}>
            <AddCircleOutlineIcon />
          </ListItemIcon>
          <span>{t("vouchersPage.addSlots")}</span>
        </MenuItem>

        <MenuItem
          className={styles.voucherMenuItem}
          sx={{
            display: "flex",
            padding: "10px",
            fontFamily: "Raleway",
            fontWeight: "500",
            fontSize: "14px",
            lineHeight: "20px",
            color: "#3E444A",
            borderRadius: "8px",
            "&:hover": { background: "#F0F8FF", color: "#0090D1" },
          }}
          onClick={() => {
            handleClose();
            setEditVoucherName(voucherName);
            setEditVoucherStartKitIssueType(startKitIssueType);
            setEditExpirationDate(expireDate)
            setIsEditVoucherModalOpen(true);
          }}
        >
          <ListItemIcon sx={{ minWidth: "24px" }}>
            <img src={editIcon} alt="Редактировать" />
          </ListItemIcon>
          <span style={{ marginRight: "auto" }}>{t("buttons.edit")}</span>
        </MenuItem>
        {isVoucherActive ? (
          <MenuItem
            className={styles.voucherMenuItem}
            onClick={() => {
              handleClose();
              setIsVoucherDeactivateModalOpen(true);
            }}
            sx={{
              display: "flex",
              borderRadius: "8px",
              padding: "10px",
              fontFamily: "Raleway",
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "20px",
              color: "#3E444A",
              "&:hover": {
                background: "#F0F8FF",
                color: "#0090D1",
              },
            }}
          >
            <ListItemIcon>
              <img src={closeIcon} alt="Закрыть" />
            </ListItemIcon>
            <span style={{ marginRight: "auto" }}>{t("vouchersPage.deactivate")}</span>
          </MenuItem>
        ) : (
          <MenuItem
            className={styles.voucherMenuItem}
            onClick={() => {
              handleClose();
              if (dayjs().isAfter(dayjs(expireDate), 'day')) {
                setIsExpiredModalOpen(true);
              }
              else {
                setIsVoucherActivateModalOpen(true);
              }
            }}
            sx={{
              display: "flex",
              borderRadius: "8px",
              padding: "10px",
              fontFamily: "Raleway",
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "20px",
              color: "#3E444A",
              "&:hover": {
                background: "#F0F8FF",
                color: "#0090D1",
              },
            }}
          >
            <ListItemIcon>
              <CheckIcon />
            </ListItemIcon>
            <span style={{ marginRight: "auto" }}>{t("vouchersPage.activate")}</span>
          </MenuItem>
        )}
      </Menu>

      <Dialog
        open={isAddNewSlotesModalOpen}
        onClose={handleAddNewSlotesModalClose}
        disableScrollLock={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        fullWidth={true}
        maxWidth="md"
        sx={{
          ".MuiDialog-paper": {
            borderRadius: "16px",
            padding: "24px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle sx={{ px: 0 }}>{t("vouchersPage.addSlots")}</DialogTitle>
          <img
            onClick={handleAddNewSlotesModalClose}
            src={closeIcon}
            className={styles.modalCloseIcon}
            alt="Закрыть"
          />
        </Box>
        <DialogContent sx={{ px: 0 }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            {fields.map((field, index) => {
              const selectedDistance = watchFields?.[index].value;
              const selectedMarathon = marathonDistances?.find(
                (marathon) => marathon?.id === selectedDistance
              );
              const selectedDistances =
                watchFields?.map((item) => item.value) || [];

              const handleDistanceChange = (event) => {
                const newDistance = event.target.value;
                setValue(`fields.${index}.value`, newDistance);
                setValue(`fields.${index}.slots`, "");
              };

              return (
                <Box>
                  <Stack
                    key={field.id}
                    direction="row"
                    spacing={2}
                    display="flex"
                    alignItems="center"
                    mb="15px"
                  >
                    <Box sx={{ width: "70%", position: "relative" }}>
                      <InputLabel htmlFor={`distance${index}`} sx={Label}>
                        {t("corporateClient.distance")}
                      </InputLabel>
                      <Controller
                        name={`fields.${index}.value`}
                        control={control}
                        rules={{ required: t("createVoucher.chooseDicstance"), }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            fullWidth
                            displayEmpty
                            defaultValue=""
                            value={field.value || ""}
                            onChange={(e) => {
                              field.onChange(e);
                              handleDistanceChange(e);
                              trigger(`fields.${index}.value`);
                            }}
                            sx={{
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderRadius: "13px",
                                border: errors.fields?.[index]?.value
                                  ? "2px solid #b63d3c"
                                  : "1px solid #C0D4E3",
                              },
                              backgroundColor: "white",
                              "& .MuiInputBase-input": {
                                padding: "10px",
                              },
                              cursor: "pointer",
                            }}
                          >
                            <MenuItem value="">
                              <Typography
                                disabled
                                className={styles.selectPlaceholder}
                              >
                                {t("createVoucher.chooseDicstance")}
                              </Typography>
                            </MenuItem>
                            {marathonDistances?.map((marathonDistance) => (
                              <MenuItem
                                key={marathonDistance?.id}
                                value={marathonDistance?.id}
                                disabled={selectedDistances?.includes(
                                  marathonDistance?.id
                                )}
                              >
                                {marathonDistance?.name}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {errors.fields?.[index]?.value && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{
                            position: "absolute",
                            bottom: "-20px",
                            left: 0,
                          }}
                        >
                          {errors.fields?.[index]?.value?.message || " "}
                        </Typography>
                      )}
                    </Box>
                    <Box sx={{ width: "30%", position: "relative" }}>
                      <InputLabel sx={Label}>{t("vouchersPage.table.slots")}</InputLabel>

                      <Controller
                        name={`fields.${index}.slots`}
                        control={control}
                        rules={{ required: t("createVoucher.enterSlots") }}
                        render={({ field }) => (
                          <TextField
                            {...field}
                            fullWidth
                            type="number"
                            placeholder={t("createVoucher.enterSlots")}
                            disabled={
                              !selectedMarathon ||
                              selectedMarathon?.remainingPlaces === 0
                            }
                            inputProps={{
                              min: 1,
                              max: selectedMarathon?.remainingPlaces || 0,
                            }}
                            onChange={(e) => {
                              const value = Math.min(
                                Number(e.target.value),
                                selectedMarathon?.remainingPlaces || 0
                              );
                              setValue(
                                `fields.${index}.slots`,
                                value.toString()
                              );
                              trigger(`fields.${index}.slots`);
                            }}
                            sx={{
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderRadius: "13px",
                                border: errors.fields?.[index]?.slots
                                  ? "2px solid #b63d3c"
                                  : "1px solid #C0D4E3",
                              },
                              backgroundColor: "white",
                              "& .MuiInputBase-input": {
                                padding: "10px",
                                textAlign: "center",
                              },
                              cursor: "pointer",
                            }}
                          />
                        )}
                      />
                      {errors.fields?.[index]?.slots && (
                        <Typography
                          color="error"
                          variant="caption"
                          sx={{
                            position: "absolute",
                            bottom: "-20px",
                            left: 0,
                          }}
                        >
                          {errors.fields?.[index]?.slots?.message || " "}
                        </Typography>
                      )}
                    </Box>

                    <IconButton
                      onClick={() => remove(index)}
                      disabled={fields.length === 1}
                    >
                      <Remove sx={{ marginTop: "17px" }} />
                    </IconButton>
                  </Stack>
                  <Box
                    sx={{
                      paddingBottom: "15px",
                      textAlign: "end",
                      paddingRight: "5%",
                      display: "flex",
                      justifyContent: "flex-end",
                      width: "100%",
                      mt: "-5px",
                    }}
                  >
                    {selectedMarathon && (
                      <Typography variant="caption" color="textSecondary">
                        {t("createVoucher.maxSpace")}:{" "}
                        {selectedMarathon?.remainingPlaces}
                      </Typography>
                    )}
                  </Box>
                </Box>
              );
            })}
            <IconButton
              onClick={() => append({ value: "", slots: "" })}
              className={styles.addButton}
            >
              <AddOutlinedIcon />
              <Typography>{t("createVoucher.addOtherDistance")}</Typography>
            </IconButton>
            <DialogActions sx={{ px: 0 }}>
              <Button
                type="button"
                variant="text"
                onClick={handleAddNewSlotesModalClose}
                sx={{
                  textTransform: "none",
                  color: "#0090D1",
                }}
              >
                {t("createVoucher.cancel")}
              </Button>
              <Button
                type="submit"
                variant="contained"
                sx={{
                  backgroundColor: "#0090D1",
                  borderRadius: "12px",
                  padding: "8px 24px",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#0090D1",
                  },
                }}
              >
                {t("createVoucher.save")}
              </Button>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>

      {/*EDIT VOUCHER */}
      <Dialog
        open={isEditVoucherModalOpen}
        onClose={handleEditVoucherModalClose}
        disableScrollLock={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        fullWidth={true}
        sx={{
          ".MuiDialog-paper": {
            borderRadius: "16px",
            padding: "24px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle sx={{ px: 0 }}>
            {" "}
            {t("buttons.edit")} {isSubvoucher ? "субваучер" : "ваучер"}
          </DialogTitle>
          <img
            onClick={handleEditVoucherModalClose}
            src={closeIcon}
            className={styles.modalCloseIcon}
            alt="Закрыть"
          />
        </Box>
        <DialogContent sx={{ px: 0 }}>
          <form onSubmit={editVoucherSubmit} id="editVoucherForm">
            <InputLabel htmlFor="editVoucherNameInput" sx={Label}>
              {t("createMarathon.name")}
            </InputLabel>
            <TextField
              type="text"
              id="editVoucherNameInput"
              value={editVoucherName}
              autoFocus
              fullWidth
              onChange={(e) => setEditVoucherName(e.target.value)}
              sx={Input}
              placeholder={t("createVoucher.voucherName")}
            />
            {isSubvoucher ? (<Box sx={{ paddingTop: '16px' }}>
              <InputLabel
                htmlFor="addResponsibleUser"
                sx={Label}
              >
                {t("vouchersPage.subvoucherResponsible")}
              </InputLabel>
              <Autocomplete
                key={selectedUsers.length}
                value={null}
                id="addResponsibleUser"
                inputValue={inputValue}
                disablePortal={false}
                size="small"
                sx={{
                  ...createVoucherAutoComplete,
                  width: "100%",
                  marginBottom: "16px",
                }}
                options={availableOptions}
                getOptionLabel={(option) => option.email || ""}
                isOptionEqualToValue={(option, value) =>
                  option.id === value.id
                }
                defaultValue={responsibleUsers ?? []}
                onChange={(event, option) => {
                  setCurrentUser(option);

                  if (option) {
                    setSelectedUsers((prevSelectedUsers) => {
                      if (
                        !prevSelectedUsers?.find(
                          (user) => user?.id === option?.id
                        )
                      ) {
                        return [...prevSelectedUsers, option];
                      }
                      return prevSelectedUsers;
                    });
                  }
                  setInputValue("");
                  setErrorFinal("");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // helperText={errorFinal}
                    // required={requiredUser}
                    placeholder={t("vouchersPage.selectUser")}
                    // sx={createVoucherDistanceName}
                    error={!!(errorFinal && selectedUsers?.length === 0)}
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <li
                      {...props}
                      key={option.id}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span className={styles.optionName}>
                        {option.email} | {option.name} {option.surname}
                      </span>
                      <span
                        style={{
                          fontSize: 12,
                          color: "#68717B",
                        }}
                      ></span>
                    </li>
                  );
                }}
                loading={isGetUsersLoading}
                loadingText={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress size={30} />
                  </div>
                }
                onInputChange={(event, value) => {
                  setInputValue(value);
                }}
              />
              <div className={styles.selectedEmails}>

                {selectedUsers?.length > 0 ? (
                  <Grid style={{ width: "98%", padding: "10px" }}>
                    {selectedUsers?.map((user) => (
                      <Grid
                        sx={{
                          width: "100%",
                          display: "flex",
                          paddingTop: "10px",
                          justifyContent: "space-between",
                        }}
                      >
                        <Grid key={user.id}>{user.email}</Grid>
                        <Button
                          onClick={() => handleRemoveUser(user.id)}
                          className={styles.removeButton}
                        >
                          <ClearIcon />
                        </Button>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <></>
                )}
              </div>
            </Box>) : <></>}

            {showExpirationDate ? null : (
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
                <InputLabel
                  htmlFor="expirationDate"
                  sx={{ ...Label, mt: "16px" }}
                >
                  {t("createVoucher.period")}
                </InputLabel>
                <Box sx={{ mt: "8px", mb: "8px" }}>
                  <DesktopDatePicker
                    inputFormat="DD.MM.YYYY"
                    value={editExpirationDate ? dayjs(editExpirationDate) : null}
                    onChange={(date) => {
                      const parsedDate = dayjs(date, "DD.MM.YYYY", true);

                      if (parsedDate.isValid()) {
                        const isTooEarly = parsedDate.isBefore(now);
                        const isTooLate = maxDate && parsedDate.isAfter(maxDate);

                        // если регистрация завершена — не показываем ошибку
                        if (isRegistrationOver) {
                          setIsInvalidExpirationDate(false);
                        } else if (isTooEarly || isTooLate) {
                          setIsInvalidExpirationDate(true);
                        } else {
                          setIsInvalidExpirationDate(false);
                        }

                        setEditExpirationDate(parsedDate.set("hour", 12).set("minute", 0).set("second", 0));
                      } else {
                        setIsInvalidExpirationDate(true);
                        setEditExpirationDate(null);
                      }
                    }}
                    minDate={dayjs().startOf("day")}
                    maxDate={!isRegistrationOver ? maxDate : undefined}
                    disabled={isRegistrationOver}
                    components={{ OpenPickerIcon: Calendar }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        autoComplete="off"
                        sx={{ ...Input, width: "100%" }}
                        inputProps={{
                          ...params.inputProps,
                          placeholder: t("createVoucher.enterDate"),
                        }}
                        disabled={isRegistrationOver}
                        error={!isRegistrationOver && isInvalidExpirationDate}
                        helperText={
                          isRegistrationOver
                            ? t("createVoucher.registrationClosed")
                            : isInvalidExpirationDate
                              ? t("createVoucher.invalidDate")
                              : params.helperText
                        }
                      />
                    )}
                  />
                </Box>
              </LocalizationProvider>
            )}

            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mt: "10px",
                }}
              >
                <InputLabel htmlFor="expirationDateIndefinite" sx={{ ...Label, fontWeight: "bold", fontSize: "15px", color: "#1976d2" }}>
                  {t("createVoucher.createIndefiniteVoucher")}
                </InputLabel>

                <Switch
                  id="expirationDateIndefinite"
                  checked={expirationDateIndefinite}
                  onChange={(e) => {
                    setShowExpirationDate(e.target.checked);
                    setExpirationDateIndefinite(e.target.checked)
                    localStorage.setItem(`voucher_${voucherName}_indefinite`, JSON.stringify(e.target.checked));
                    if (e.target.checked && endDateAcceptingApplications) {
                      const endDate = dayjs(endDateAcceptingApplications).set("hour", 12).set("minute", 0).set("second", 0).toISOString();;
                      setEditExpirationDate(endDate);
                    } else {
                      setEditExpirationDate(editExpirationDate);
                    }
                  }}
                />
              </Box>
            </Grid>

          </form>
        </DialogContent>
        <DialogActions sx={{ px: 0 }}>
          <Button
            type="button"
            variant="text"
            onClick={handleEditVoucherModalClose}
            sx={{
              textTransform: "none",
              color: "#0090D1",
            }}
          >
            {t("createVoucher.cancel")}
          </Button>
          <Button
            type="submit"
            form="editVoucherForm"
            variant="contained"
            disabled={editVoucherLoading || isInvalidExpirationDate}
            sx={{
              backgroundColor: "#0090D1",
              borderRadius: "12px",
              padding: "8px 24px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#0090D1",
              },
            }}
          >
            {t("createVoucher.save")}
            {editVoucherLoading && (
              <CircularProgress size={20} sx={defaultCircularProgress} />
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* DEACTIVATE VOUCHER */}
      <Dialog
        open={isVoucherDeactiveModalOpen}
        onClose={handleVoucherDeactivateModalClose}
        // disableScrollLock={true}
        fullWidth={true}
        maxWidth="xs"
        sx={{
          ".MuiDialog-paper": {
            borderRadius: "16px",
            padding: "24px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle
            sx={{
              px: 0,
              fontFamily: "Raleway, sans-serif",
              fontSize: "20px",
              fontWeight: 600,
              lineHeight: "24px",
            }}
          >
            {t("createVoucher.maxSpace")}
          </DialogTitle>
          <img
            onClick={handleVoucherDeactivateModalClose}
            src={closeIcon}
            className={styles.modalCloseIcon}
            alt="Закрыть"
          />
        </Box>
        <DialogContent sx={{ px: 0 }}>
          <Typography className={styles.editVoucherText}>
            {t("vouchersPage.confirmDeactivateVoucher")} <b>{voucherName}</b>
          </Typography>
          <Divider sx={{ width: "100%" }} />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "flex-start", px: 0 }}>
          <Button
            type="button"
            variant="contained"
            onClick={(e) => handleIsActivationVoucher(e, false)}
            disabled={editVoucherLoading}
            sx={{
              backgroundColor: "#0090D1",
              borderRadius: "12px",
              padding: "8px 10px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#0090D1",
              },
            }}
          >
            {t("vouchersPage.confirmDeactivate")}
            {editVoucherLoading && (
              <CircularProgress size={20} sx={defaultCircularProgress} />
            )}
          </Button>
          <Button
            type="button"
            variant="text"
            onClick={handleVoucherDeactivateModalClose}
            sx={{
              textTransform: "none",
              color: "#0090D1",
            }}
          >
            {t("vouchersPage.cancel")}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ACTIVATE VOUCHER */}
      <Dialog
        open={isVoucherActivateModalOpen}
        disableScrollLock={true}
        onClose={handleVoucherActivateModalClose}
        fullWidth={true}
        maxWidth="xs"
        sx={{
          ".MuiDialog-paper": {
            borderRadius: "16px",
            padding: "24px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle sx={ModalTitle}>{t("vouchersPage.activateVoucher")}</DialogTitle>
          <img
            onClick={handleVoucherActivateModalClose}
            src={closeIcon}
            className={styles.modalCloseIcon}
            alt="Закрыть"
          />
        </Box>
        <DialogContent sx={{ px: 0 }}>
          <Typography className={styles.editVoucherText}>
            {t("vouchersPage.confirmActivateVoucher")} <b>{voucherName}</b>
          </Typography>
        </DialogContent>
        <Divider sx={{ width: "100%" }} />
        <DialogActions sx={{ justifyContent: "flex-start", px: 0 }}>
          <Button
            type="button"
            onClick={(e) => handleIsActivationVoucher(e, true)}
            variant="contained"
            disabled={editVoucherLoading}
            sx={{
              backgroundColor: "#0090D1",
              borderRadius: "12px",
              padding: "8px 24px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#0090D1",
              },
            }}
          >
            {t("vouchersPage.confirmActivate")}
            {editVoucherLoading && (
              <CircularProgress size={20} sx={defaultCircularProgress} />
            )}
          </Button>
          <Button
            type="button"
            variant="text"
            onClick={handleVoucherActivateModalClose}
            sx={{
              textTransform: "none",
              color: "#0090D1",
            }}
          >
            {t("vouchersPage.cancel")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isExpiredModalOpen}
        disableScrollLock={true}
        onClose={handleExpiredModalClose}
        fullWidth={true}
        maxWidth="xs"
        sx={{
          ".MuiDialog-paper": {
            borderRadius: "16px",
            padding: "24px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle sx={ModalTitle}>{t("vouchersPage.expiredActivateVoucher")}</DialogTitle>
          <img
            onClick={handleExpiredModalClose}
            src={closeIcon}
            className={styles.modalCloseIcon}
            alt="Закрыть"
          />
        </Box>
        <DialogContent sx={{ px: 0 }}>
          <Typography className={styles.editVoucherText}>
            {t("vouchersPage.changeDateActivateVoucher")} <b>{voucherName}?</b>
          </Typography>
        </DialogContent>
        <Divider sx={{ width: "100%" }} />
        <DialogActions sx={{ justifyContent: "flex-start", px: 0 }}>
          <Button
            type="button"
            onClick={(e) => {
              setIsExpiredModalOpen(false)
              setEditVoucherName(voucherName);
              setEditVoucherStartKitIssueType(startKitIssueType);
              setEditExpirationDate(expireDate)
              setIsEditVoucherModalOpen(true)
            }}
            variant="contained"
            disabled={editVoucherLoading}
            sx={{
              backgroundColor: "#0090D1",
              borderRadius: "12px",
              padding: "8px 24px",
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#0090D1",
              },
            }}
          >
            {t("vouchersPage.editActivate")}
            {editVoucherLoading && (
              <CircularProgress size={20} sx={defaultCircularProgress} />
            )}
          </Button>
          <Button
            type="button"
            variant="text"
            onClick={handleExpiredModalClose}
            sx={{
              textTransform: "none",
              color: "#0090D1",
            }}
          >
            {t("vouchersPage.cancel")}
          </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
};

export default SubVoucher;
